export const loginForm = [
    {
        cols: [
            {
                formGroup: 'loginForm',
                class: 'col-lg-8 col-10',
                title: 'Acceso al área de clientes',
                titleClass: 'form-title text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                item: 'input',
                type: 'email',
                required: true,
                placeholder: 'Email',
                inputClass: 'text-input',
                formControlName: 'email'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                item: 'input',
                type: 'password',
                required: true,
                placeholder: 'Contraseña',
                inputClass: 'text-input',
                formControlName: 'pass'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                item: 'button',
                type: 'regular',
                submit: 'true',
                placeholder: 'Acceder',
                inputClass: 'form-button btn btn-primary'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10 mb-1 mb-sm-5 forgot-password',
                item: 'a',
                link: '/forgot-password',
                placeholder: 'He olvidado la contraseña',
                inputClass: 'form-anchor',
                buttonAction: 'forgotPassword'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10 mt-1 mt-sm-3',
                title: '¿Aún no tienes acceso al Área de Cliente?',
                titleClass: 'form-title-2 text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10 mt-3',
                item: 'button',
                type: 'regular',
                placeholder: 'Activar acceso al Área de Clientes',
                inputClass: 'form-button btn btn-primary btn-activar',
                buttonAction: 'goToAccessRequest'
            }
        ]
    }
];

